const CapitalLog = {
  path: '/Accounts/CapitalLog',
  component: resolve => require(['@/views/Accounts/CapitalLog'], resolve),
  name: 'CapitalLog',
  meta: {title: '资金日志'}
};
const redpackLog = {
  path: '/Accounts/redpackLog',
  component: resolve => require(['@/views/Accounts/redpackLog'], resolve),
  name: 'CapitalLog',
  meta: {title: '红包记录'}
};
const rechargeTotal = {
  path: '/Accounts/rechargeTotal',
  component: resolve => require(['@/views/Accounts/rechargeTotal'], resolve),
  name: 'rechargeTotal',
  meta: {title: '充值统计'}
};
const rechargeCheck = {
    path: '/Accounts/rechargeCheck',
    component: resolve => require(['@/views/Accounts/rechargeCheck'], resolve),
    name: 'rechargeCheck',
    meta: {title: '充值核对'}
  };
const returnRecord = {
    path: '/Accounts/returnRecord',
    component: resolve => require(['@/views/Accounts/returnRecord'], resolve),
    name: 'returnRecord',
    meta: {title: '返现记录'}
  };
const returnCash = {
  path: '/Accounts/returnCash',
  component: resolve => require(['@/views/Accounts/returnCash'], resolve),
  name: 'returnCash',
  meta: {title: '返现提现'}
};
const returnCashDetail = {
  path: '/Accounts/returnCashDetail',
  component: resolve => require(['@/views/Accounts/returnCashDetail'], resolve),
  name: 'returnCashDetail',
  meta: {title: '返现提现详情'},
  hidden: true
};
const returnActivity = {
  path: '/Accounts/returnActivity',
  component: resolve => require(['@/views/Accounts/returnActivity'], resolve),
  name: 'returnActivity',
  meta: {title: '返现活动'}
};
const returnActivityDetail = {
  path: '/Accounts/returnActivityDetail',
  component: resolve => require(['@/views/Accounts/returnActivityDetail'], resolve),
  name: 'returnActivityDetail',
  meta: {title: '活动城市详情'},
  hidden: true
};

export default [CapitalLog, redpackLog,rechargeTotal,rechargeCheck, returnRecord, returnCash,returnActivity,returnCashDetail,returnActivityDetail];




// WEBPACK FOOTER //
// ./src/router/modules/Accounts.js